import React, { useMemo } from "react";

import { STRIPE_PUBLISHABLE_API_KEY } from "util/env";

import WestIcon from "@mui/icons-material/West";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Stepper } from "components/molecules/Stepper";
import { CheckoutForm } from "components/organisms/CheckoutForm";
import { useTranslation } from "react-i18next";

type Props = {
  goBack: () => void;
  clientSecret: undefined | string;
};

export const Presenter: React.FC<Props> = (props) => {
  const { t, i18n } = useTranslation();
  const { goBack, clientSecret } = props;

  let stripeLocale: "ja" | "zh" | "en";
  switch (i18n.language) {
    case "ja":
      stripeLocale = "ja";
      break;
    case "en":
      stripeLocale = "en";
      break;
    case "zh":
      stripeLocale = "zh";
      break;
    default:
      stripeLocale = "ja";
  }

  // see: https://docs.stripe.com/js/appendix/supported_locales
  const stripePromise = useMemo(
    () => loadStripe(STRIPE_PUBLISHABLE_API_KEY, { locale: stripeLocale }),
    [stripeLocale]
  );

  const appearance = {
    theme: "stripe" as "stripe",
  };

  const options = {
    layout: {
      type: "accordion",
      defaultCollapsed: false,
      radios: true,
      spacedAccordionItems: false,
    },
    clientSecret: clientSecret,
    appearance: appearance,
  };

  return (
    <Box>
      <IconButton onClick={goBack} sx={{ color: "func.100", width: 40 }}>
        <WestIcon />
      </IconButton>
      <Box padding={2}>
        <Stepper activeStep={1} />
      </Box>
      <Stack spacing={3} alignItems="center">
        <Typography variant="h2">{t("payment.title")}</Typography>
        <Typography variant="bold14">{t("payment.description")}</Typography>
        <Elements stripe={stripePromise} options={options}>
          {clientSecret && (
            <Box padding={2} width="100%">
              <CheckoutForm clientSecret={clientSecret} />
            </Box>
          )}
        </Elements>
      </Stack>
    </Box>
  );
};
